import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { getApiEndpoint } from '../config/api';

const AdminDashboard = () => {
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProperties();
    }, []);

    const fetchProperties = async () => {
        try {
            const response = await axios.get(getApiEndpoint('admin_properties.php'));
            setProperties(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching properties", error);
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this property?")) {
            try {
                await axios.delete(getApiEndpoint(`admin_properties.php?id=${id}`));
                // Refresh list
                fetchProperties();
            } catch (error) {
                console.error("Error deleting property", error);
                alert("Failed to delete property");
            }
        }
    };

    if (loading) return <div className="p-8">Loading...</div>;

    return (
        <div>
            <div className="admin-header">
                <h2>Dashboard</h2>
                <Link to="/admin/properties/add" className="admin-btn-primary">
                    <Plus size={20} /> Add Property
                </Link>
            </div>

            <div className="admin-table-container">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Type</th>
                            <th>Price</th>
                            <th>Location</th>
                            <th style={{ textAlign: 'right' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {properties.map((property) => (
                            <tr key={property.id}>
                                <td>
                                    <img src={property.image_url} alt={property.title} className="admin-table-img" />
                                </td>
                                <td>{property.title}</td>
                                <td>{property.type}</td>
                                <td>₹{property.price}</td>
                                <td>{property.location}</td>
                                <td style={{ textAlign: 'right' }}>
                                    <Link to={`/admin/properties/edit/${property.id}`} className="admin-action-btn edit">
                                        <Edit size={18} />
                                    </Link>
                                    <button onClick={() => handleDelete(property.id)} className="admin-action-btn delete">
                                        <Trash2 size={18} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminDashboard;
